// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HowItWorks {\n  padding-bottom: 24px;\n}\n", "",{"version":3,"sources":["webpack://./src/app/logic/pages/introduction/HowItWorks.less"],"names":[],"mappings":"AAAA;EACI,oBAAA;AACJ","sourcesContent":[".HowItWorks {\n    padding-bottom: 24px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
